<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" sm="12" md="6" lg="5">
        <!-- patient card start -->
        <b-col>
          <iq-card class-name="iq-user-profile-block1">
            <template v-slot:body>
              <div class="user-details-block">
                <div class="user-profile text-center">
                  <img v-if="patient.gender !== null && patient.gender === 0" src="../../assets/images/user/11.png" alt="profile-img"
                       class="avatar-130 img-fluid">
                  <img v-else src="../../assets/images/user/19.png" alt="profile-img" class="avatar-130 img-fluid">
                </div>
                <div class="text-center mt-3">
                  <!--              <h3><b>编号：{{patient.pdid}}</b></h3>-->
                  <h6 class="text-primary">{{$t('main.DashboardCkd.patientCard.originDisease')}}</h6>
                  <h4><b>{{getLocale() ? patient.originDisease : originMedicalChartEn[patient.originDisease]}}</b></h4>
                </div>
                <ul class="doctoe-sedual d-flex align-items-center justify-content-between p-0 mt-4 mb-0">
                  <li class="text-center">
                    <h6 class="text-primary">{{$t('main.DashboardCkd.patientCard.id')}}</h6>
                    <h4 v-if="$route.params.patientId.charAt(0) == 'a'">{{$route.params.patientId}}</h4>
                    <h4 v-else> - </h4>
                  </li>
                  <li class="text-center">
                    <h6 class="text-primary">{{$t('main.DashboardCkd.patientCard.gender')}}</h6>
                    <h4 v-if="patient.gender !== null && patient.gender === 0">{{$t('main.general.female')}}</h4>
                    <h4 v-else>{{$t('main.general.male')}}</h4>
                  </li>
                  <li class="text-center">
                    <h6 class="text-primary">{{$t('main.DashboardCkd.patientCard.birth')}}</h6>
                    <h4 v-if="patient.birthDate != null">{{patient.birthDate.substring(0,4)}}</h4>
                    <h4 v-else>{{$t('main.general.noData')}}</h4>
                  </li>
                </ul>
                <br />
                <div class="d-flex align-items-center justify-content-between">
                  <b-col>
                    <div class="data-block">
                      <p class="mb-0">{{$t('main.DashboardCkd.patientCard.height')}}</p>
                      <h5 v-if="patient.height == undefined">{{$t('main.general.noData')}}</h5>
                      <div v-else>
                        <h5>{{change(patient.height)}}&nbsp;<span>cm</span></h5>
                      </div>
                    </div>
                    <div class="data-block mt-3">
                      <p class="mb-0">{{$t('main.DashboardCkd.patientCard.weight')}}</p>
                      <h5 v-if="patient.weight == undefined">{{$t('main.general.noData')}}</h5>
                      <div v-else>
                        <h5>{{change(patient.weight)}}&nbsp;<span>kg</span></h5>
                      </div>
                    </div>
                    <div class="data-block mt-3">
                      <p class="mb-0">{{$t('main.DashboardCkd.patientCard.admissionAge')}}</p>
                      <h5 v-if="patient.age == undefined">{{$t('main.general.noData')}}</h5>
                      <div v-else>
                        <h5>{{patient.age}}&nbsp;<span>{{$t('main.general.yearsOld')}}</span></h5>
                      </div>
                    </div>
                    <div class="data-block mt-3" v-if="patient.death == 1">
                      <p class="mb-0">{{$t('main.DashboardCkd.patientCard.deadTime')}}</p>
                      <h5>{{patient.deathDate.substring(0,7)}}</h5>
                    </div>
                    <div class="data-block mt-3" v-else>
                      <p class="mb-0">{{$t('main.DashboardCkd.patientCard.status')}}</p>
                      <h5>{{$t('main.DashboardCkd.patientCard.cure')}}</h5>
                    </div>
<!--                      <div class="data-block mt-3"-->
<!--                           v-show="patient.amputation === 1 || patient.ch === 1 || patient.ci === 1 || patient.mi === 1 || patient.chd === 1 || patient.lung_infect === 1 || patient.heart_failure === 1 || patient.diabetes === 1">-->
<!--                        <p class="mb-0">{{$t('main.DashboardCkd.patientCard.basicDisease')}}</p>-->
<!--                        <h5>{{(patient.diabetes === 1 ? '糖尿病 ' : '') +-->
<!--                        (patient.heart_failure === 1 ? '心脏衰竭 ' : '') +-->
<!--                        (patient.lung_infect === 1 ? '肺部感染 ' : '') +-->
<!--                        (patient.chd === 1 ? '冠心病 ' : '') +-->
<!--                        (patient.mi === 1 ? '心梗 ' : '') +-->
<!--                        (patient.ci === 1 ? '脑梗 ' : '') +-->
<!--                        (patient.ch === 1 ? '脑出血 ' : '') +-->
<!--                        (patient.amputation === 1 ? '截肢 ' : '')}}</h5>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3" v-show="patient.death == 1">-->
<!--                        <p class="mb-0">{{$t('main.DashboardCkd.patientCard.deadCause')}}</p>-->
<!--                        <h5>{{getLocale() ? patient.deathReasonText : deathReasonEn[patient.deathReasonText]}}</h5>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3" v-show="analyze['cluster_id'] !== undefined">-->
<!--                        <p class="mb-0">{{$t('main.DashboardCkd.patientCard.cluster')}}</p>-->
<!--                        <h5><span>{{$t('main.DashboardCkd.patientCard.clusterNo1')}} </span>{{analyze.cluster_id}} <span> {{$t('main.DashboardCkd.patientCard.clusterNo2')}}</span></h5>-->
<!--                      </div>-->
                  </b-col>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-col>
      <b-col>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{$t('main.general.indicators')}}</h4>
          </template>
          <template v-slot:headerAction>
            <div style="padding-right: 20px">
              <a @click="$store.commit('setSelectedGraph', [])">
                <span>{{$t('main.general.clearSelected')}}</span>
              </a>
            </div>
          </template>
          <template v-slot:body>
            <div class="iq-card-body pl-0 pr-0 pb-0" v-show="patient_data_selector.length">
              <PatientDataSelector :item="patient_data_selector" :langType="getLocale()">
              </PatientDataSelector>
            </div>
          </template>
        </iq-card>
        <PatientDataChart v-if=" rePatientChart && analyze !==undefined && (selectedGraph.length>= 1 || analyze.predict !== undefined)" />
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <iq-card body-class="bg-primary rounded pt-2 pb-2 pr-2">
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="mb-0" style="font-size: 22px;margin-left: 10px;color: white;"> {{$t('main.esrdProtoCare.prototypeInformation')}}<i
                class="fa fa-id-card" style="margin-left: 5px;"></i>
              </h4>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="7">
        <LineChart :order="prototypeOrder" width="750px"/>
      </b-col>
      <b-col lg="5">
        <iq-card class-name="iq-card-block iq-card-stretch">
          <template v-slot:headerTitle>
            <h4 class="card-title">{{$t('main.esrdProtoCare.statistics')}}</h4>
          </template>
          <template v-slot:body>
            <div class="table-responsive" style="margin-left: 5px;">
              <table class="table mb-0 table-borderless">
                <thead>
                <tr>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{$t('main.esrdProtoCare.prototypeId')}}</th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{$t('main.esrdProtoCare.age')}}</th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{$t('main.esrdProtoCare.gender')}}</th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{$t('main.esrdProtoCare.deathRate')}}</th>
                  <th scope="col" style="padding: 0.25rem; text-align: center">{{$t('main.esrdProtoCare.diabetes')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="p in prototypeInfo" :key="p.id">
                  <td style="padding: 0.25rem; text-align: center">{{p.id}}</td>
                  <td style="padding: 0.25rem; text-align: center">{{p.age}}</td>
                  <td style="padding: 0.25rem; text-align: center">{{p.gender.toFixed(1)}}%</td>
                  <td style="padding: 0.25rem; text-align: center">{{p.mortality.toFixed(1)}}%</td>
                  <td style="padding: 0.25rem; text-align: center">{{p.diabetes.toFixed(1)}}%</td>
                </tr>
                </tbody>
              </table>
            </div>
<!--            <div style="margin-bottom: 100px;"></div>-->
          </template>
        </iq-card>
      </b-col>
    </b-row>
<!--    <b-row>-->
<!--      <b-col lg="12">-->
<!--        <Heatmap/>-->
<!--      </b-col>-->
<!--    </b-row>-->
  </b-container>
</template>
<script>
import IqCard from '@/components/xray/cards/iq-card'
import { xray } from '@/config/pluginInit'
import APIHelper from '@/util/APIHelper'
import { medicalChar, medicalCharChinese, deathReasonEn, originMedicalChartEn } from '@/util/info'
import PPNPatientDataChart from '@/views/Charts/PPNPatientDataChart'
import PatientDataSelector from '@/views/Charts/PatientDataSelector'
import ColorHelper from '@/util/ColorHelper'
import PPNLineChart from '@/views/Charts/PPNLineChart'

const body = document.getElementsByTagName('body')
  export default {
    name: 'Dashboard4',
    components: {
      IqCard,
      PatientDataChart: PPNPatientDataChart,
      PatientDataSelector,
      // Heatmap: EsrdProtoCareHeatmap,
      LineChart: PPNLineChart
    },
    inject: ['reload'],
    data() {
      return {
        rePatientChart: true,
        display1: false,
        urlAnalyzeApi: undefined,
        settings: undefined,
        getAnalyzeDataTimer: undefined,
        medicalCharChinese: medicalCharChinese,
        deathReasonEn,
        originMedicalChartEn,
        medicalChar: medicalChar,
        patient_data_selector: [],
        prototypeInfo: [
          { id: 5, age: 74.95, gender: 78.3, mortality: 76.1, diabetes: 45.7 },
          { id: 4, age: 72.76, gender: 7.0, mortality: 56.3, diabetes: 41.4 },
          { id: 3, age: 63.71, gender: 96.2, mortality: 42.3, diabetes: 68.3 },
          { id: 2, age: 58.31, gender: 14.4, mortality: 35.1, diabetes: 33.3 },
          { id: 1, age: 44.03, gender: 94.7, mortality: 18.2, diabetes: 22.1 },
          { id: 0, age: 38.74, gender: 11.6, mortality: 9.5, diabetes: 9.8 }
        ],
        // prototypeOrder: [5, 4, 7, 1, 6, 3, 0, 2]
        // prototypeOrder: [0, 4, 7, 5, 2, 3, 1, 6]
        prototypeOrder: [3, 2, 0, 1, 5, 4]
      }
    },
    created() {
      if (!this.$route.params.patientId) {
        this.$router.replace('/1186')
      }
      this.$store.commit('setShowValue', true)
      Promise.all([APIHelper.getPatientById(this.$route.params.patientId), APIHelper.getLabById(this.$route.params.patientId), APIHelper.getMockData(this.$route.params.patientId)])
        .then(([patient, lab, events]) => {
          if (patient['pdid'] === 1186) {
            lab[6]['crp'] = '3.2'
            lab[6]['alb'] = '34.2'
          }
          this.$store.commit('setLab', lab)
          this.$store.commit('setModifiedLab', lab)
          this.$store.commit('setPatient', patient)
        })
      if (this.$store.state.ch) {
        this.$store.commit('setCh', new ColorHelper())
      }
    },
    mounted() {
      xray.index()
      body[0].classList.add('sidebar-main-menu')
    },
    destroyed() {
      body[0].classList.remove('sidebar-main-menu')
    },
    computed: {
      selectedGraph() {
        return this.$store.state.selectedGraph
      },
      analyze() {
        return this.$store.state.analyze
      },
      modifiedLab() {
        return this.$store.state.modifiedLab
      },
      lab() {
        return this.$store.state.lab
      },
      patient() {
        return this.$store.state.patient
      },
      analyzeData() {
        const { modifiedLab, patient } = this
        return {
          modifiedLab, patient
        }
      },
      ch() {
        return this.$store.state.ch
      }
    },
    watch: {
      analyzeData() {
        this.getAnalyzeData()
      },
      '$route'(to, from) { // 监听路由是否变化
        if (to.name === 'dashboard.home-4') { // 跳转到哪个页面
          this.reload()
        }
      },
      '$i18n.locale'() {
        this.reloadChild()
      }
    },
    methods: {
      reloadChild() {
        this.rePatientChart = false
        this.$nextTick(() => {
          this.rePatientChart = true
        })
      },
      getAnalyzeData() {
        clearTimeout(this.getAnalyzeDataTimer)
        this.getAnalyzeDataTimer = setTimeout(() => this.patient && this.modifiedLab && APIHelper.getPPNAnalyze({
          patient: this.patient,
          lab: this.modifiedLab
        }).then(result => {
          this.$store.commit('setAnalyze', result)
          if (this.patient_data_selector.length === 0) {
            this.patient_data_selector = Object.keys(this.lab[0]).filter(item => item !== 'pdid' && item !== 'date')
          }
        }), 500)
      },
      change(a) {
        const b = parseFloat(a)
        return b.toFixed(1)
      },
      getLocale() {
        return this.$i18n.locale === 'chi'
      }
    }
  }
</script>
